import { useState, useEffect } from 'react';
import { Eye, X, Timer } from 'lucide-react';
import { useSimulation } from '@/contexts/SimulationContext';
import { useNavigate } from 'react-router-dom';

export default function SimulationBanner() {
  const { isSimulating, simulatedRoleName, startedAt, stopSimulation } = useSimulation();
  const navigate = useNavigate();

  const handleExit = () => {
    stopSimulation();
    navigate('/roles');
  };

  const [elapsedTime, setElapsedTime] = useState('0:00');

  useEffect(() => {
    if (!isSimulating || !startedAt) return;

    const updateElapsed = () => {
      const elapsed = Math.floor((Date.now() - startedAt.getTime()) / 1000);
      const minutes = Math.floor(elapsed / 60);
      const seconds = elapsed % 60;
      setElapsedTime(`${minutes}:${seconds.toString().padStart(2, '0')}`);
    };

    updateElapsed();
    const interval = setInterval(updateElapsed, 1000);
    return () => clearInterval(interval);
  }, [isSimulating, startedAt]);

  if (!isSimulating) {
    return null;
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-amber-500 to-orange-500 text-white py-2 px-4 flex items-center justify-center gap-3 shadow-lg"
    >
      <Eye size={20} />

      <span className="font-bold text-sm">MODO SIMULACION</span>

      <span className="px-2 py-0.5 bg-white/20 rounded text-xs font-bold">
        {simulatedRoleName || 'Rol desconocido'}
      </span>

      <div className="flex items-center gap-1 ml-2">
        <Timer size={16} />
        <span className="text-sm">{elapsedTime}</span>
      </div>

      <span className="text-sm opacity-90 mx-2 hidden sm:inline">
        Estas viendo el sistema como si tuvieras este rol
      </span>

      <button
        onClick={handleExit}
        className="flex items-center gap-1.5 px-3 py-1 bg-white text-orange-600 rounded text-sm font-bold hover:bg-white/90 transition-colors"
      >
        <X size={16} />
        Salir y Volver al Editor
      </button>
    </div>
  );
}
